import { Column } from '@tanstack/react-table';
import { CSSProperties } from 'react';

export const getCommonPinningStyles = <T>(
  _: 'header' | 'cell',
  column: Column<T>,
): CSSProperties => {
  const isPinned = column.getIsPinned();
  // const isLastLeftPinnedColumn =
  //   isPinned === 'left' && column.getIsLastColumn('left');
  // const isFirstRightPinnedColumn =
  //   isPinned === 'right' && column.getIsFirstColumn('right');

  return {
    // borderEndEndRadius: isLastLeftPinnedColumn ? '1px solid #e2e8f0' : undefined,
    // borderLeft: isFirstRightPinnedColumn ? '1px solid #e2e8f0' : undefined,
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    width: column.getSize(),
    zIndex: isPinned ? 1 : 0,
    marginInlineStart: isPinned ? 'auto' : undefined,
  };
};
